import React from 'react'
import { Box, Text } from "grommet"
import AgDataTable from '../../common/AgDataTable'
import Spinner from '../../common/Spinner'
import { useConnection } from '../../../utils/connection'

import { HealthServiceDataViewStatus } from './HealthStatusService'
import { deepClone } from '../../../utils/clone'

const HealthStatusServiceLedgerS3Search = ({ data }) => {

    const connectionLookup = useConnection()

    const tab_col = [
        {
            field: "topicName",
            headerName: "Topic Name",
            minWidth: 200,
        },
        {
            field: "status",
            headerName: "Status",
            minWidth: 200,
            suppressSizeToFit: true,
            cellStyle: function (params) {
                if (params.value !== 'up') {
                    return { color: 'white', backgroundColor: '#B4130B' };
                } else {
                    return { color: 'black', backgroundColor: 'white' };
                }
            }
        },
    ]

    let tab_data = []
    if (connectionLookup) {
        tab_data = Object.keys(data).sort((a) => (data[a].status === 'up') ? 1 : -1).reduce((rowData, rowName) => {

            const row = deepClone(data[rowName])
            const topicName = row.name

            rowData.push({
                'topicName': topicName,
                'status': row.status
            })

            return rowData
        }, [])
    }

    return (
        <Box border="top" margin={{ top: "small", left: "xsmall", right: "xsmall" }} fill="horizontal">
            <Box direction="row">
                <Text margin={{ top: "8px", bottom: "8px" }} size="small" color="dark-3" weight="bold"> Topics </Text>
                <HealthServiceDataViewStatus tab_data={tab_data.map(function (item) { return item["status"] })} />
            </Box>
            {!connectionLookup
                ? <Spinner />
                :
                <AgDataTable
                    tab_col={tab_col}
                    tab_data={tab_data}
                    tableName="HealthStatusServiceLedgerS3Search"
                    defaultSubTab="Ledger S3 and Search topics"
                    countTitle="Ledger S3 and Search topics"
                    tableHeight={700}
                />
            }
        </Box>
    )
}

export default HealthStatusServiceLedgerS3Search